import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormGroupState } from 'ngrx-forms';
import memo from 'memo-decorator';

@Pipe({
  name: 'appSaveValidState',
  pure: true
})
export class AppSaveValidStatePipe implements PipeTransform {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  @memo()
  transform(form: FormGroup | FormGroupState<any>): boolean {
    if ('isValid' in form) {
      const f = form as FormGroupState<any>;
      return f.isValid;
    }

    return false;
  }
}
